/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizerfollowqrdescription3Inputs */

const en_organizerfollowqrdescription3 = /** @type {(inputs: Organizerfollowqrdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For your stand, posters and the counter: whoever scans the code lands on your page in the app, follows and taps the bell. Then they get a message for every new event. Scans count toward your credits.`)
};

const de_organizerfollowqrdescription3 = /** @type {(inputs: Organizerfollowqrdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Stand, Plakat und Theke: Wer den Code scannt, landet auf eurer Seite in der App, folgt und tippt die Glocke an. Dann kommt bei jedem neuen Event eine Nachricht. Scans zählen für euer Guthaben.`)
};

/**
* | output |
* | --- |
* | "For your stand, posters and the counter: whoever scans the code lands on your page in the app, follows and taps the bell. Then they get a message for every n..." |
*
* @param {Organizerfollowqrdescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizerfollowqrdescription3 = /** @type {((inputs?: Organizerfollowqrdescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizerfollowqrdescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizerfollowqrdescription3(inputs)
	return de_organizerfollowqrdescription3(inputs)
});
export { organizerfollowqrdescription3 as "organizerFollowQrDescription" }